(function ($) {
    var owl = $('#owl-home'),

        owlOptions = {
            loop: true,
            margin: 0,
            smartSpeed: 700,
            nav: false,
            items: 1
        };

    if ($(window).width() < 1025) {
        var owlActive = owl.owlCarousel(owlOptions);
    } else {
        owl.addClass('off');
    }

    var resizeTimer; // Set resizeTimer to empty so it resets on page load

    function resizeFunction() {
        if ($(window).width() < 1025) {
            if ($('.owl-carousel').hasClass('off')) {
                var owlActive = owl.owlCarousel(owlOptions);
                owl.removeClass('off');
            }
        } else {
            if (!$('.owl-carousel').hasClass('off')) {
                owl.addClass('off').trigger('destroy.owl.carousel');
                owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
            }
        }
    };

    $(window).resize(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(resizeFunction, 250);
    });

})(jQuery);
